/*@flow*/
import type { Node } from 'react';
import React from 'react';
import { mkComponent, type PickerProps } from './Resources';

export function IntersectingBuilding(props: PickerProps): Node {
  return React.createElement(
    mkComponent({
      placeholder: 'Select a building',
      targetRelation: 'buildings',
    }),
    props
  );
}
